import React from "react";
import Helmet from "react-helmet";

import { SITENAME, DESCRIPTION } from "../../../constants/data";

import favicon from "../../../assets/img/feedback-app-favicon.png";

const SEO = (props) => {
  const title = (
    typeof props.title === "undefined" ? "" : props.title + " | "
  ).concat(SITENAME);
  const metaDescription = props.description || DESCRIPTION;
  const meta = props.meta || [];
  const safeMeta = Array.isArray(props.meta)
  ? props.meta.filter(
      (m) =>
        m &&
        typeof m === "object" &&
        (m.name || m.property) &&
        typeof m.content === "string"
    )
  : [{ name: "description", content: metaDescription }];
console.log("SEO meta passed to Helmet:", safeMeta);

  return (
    <Helmet
      title={title}
      // titleTemplate={`%s | ${site.siteMetadata.title}`}
      link={[
        {
          rel: "icon",
          type: "image/png",
          href: favicon,
        },
      ]}
      // meta={[
      //   {
      //     name: `title`,
      //     content: title,
      //   },
      //   {
      //     name: `description`,
      //     content: metaDescription,
      //   },
      //   {
      //     property: `og:title`,
      //     content: title,
      //   },
      //   {
      //     property: `og:description`,
      //     content: metaDescription,
      //   },
      //   {
      //     property: `og:type`,
      //     content: `website`,
      //   },
      //   {
      //     name: `twitter:card`,
      //     content: `summary`,
      //   },
      //   {
      //     name: `twitter:creator`,
      //     content: title,
      //   },
      //   {
      //     name: `twitter:title`,
      //     content: title,
      //   },
      //   {
      //     name: `twitter:description`,
      //     content: metaDescription,
      //   },
      // ].concat(meta)}
      meta={[
  { name: "title", content: title },
  { name: "description", content: metaDescription },
  { property: "og:title", content: title },
  { property: "og:description", content: metaDescription },
  { property: "og:type", content: "website" },
  { name: "twitter:card", content: "summary" },
  { name: "twitter:creator", content: SITENAME },
  { name: "twitter:title", content: title },
  { name: "twitter:description", content: metaDescription },
].concat(safeMeta)}
    />
  );
};
export default SEO;
